<script>
  import uPlot from "uplot";
  import "uplot/dist/uPlot.min.css";
  import { mode } from "mode-watcher";

  let { data } = $props();

  let container;
  let chart;

  const coloredPath = (u, seriesIdx, idx0, idx1) => {
    const greenPath = new Path2D();
    const redPath = new Path2D();

    uPlot.orient(u, seriesIdx, (series, dataX, dataY, scaleX, scaleY, valToPosX, valToPosY, xOff, yOff, xDim, yDim) => {
      const pxRound = series.pxRound;
      const pixelForX = (val) => pxRound(valToPosX(val, scaleX, xDim, xOff));
      const pixelForY = (val) => pxRound(valToPosY(val, scaleY, yDim, yOff));
      const y0px = pixelForY(0);

      let currentPath = dataY[idx0] >= 0 ? greenPath : redPath;
      currentPath.moveTo(pixelForX(dataX[idx0]), pixelForY(dataY[idx0]));

      for (let i = idx0 + 1; i <= idx1; i++) {
        const prevPositive = dataY[i - 1] >= 0;
        const currPositive = dataY[i] >= 0;

        if (prevPositive !== currPositive) {
          const frac =
            Math.abs(dataY[i - 1]) /
            (Math.abs(dataY[i - 1]) + Math.abs(dataY[i]));
          const crossX =
            dataX[i - 1] + frac * (dataX[i] - dataX[i - 1]);
          const crossPx = pixelForX(crossX);

          currentPath.lineTo(crossPx, y0px);
          currentPath = currPositive ? greenPath : redPath;
          currentPath.moveTo(crossPx, y0px);
        }

        currentPath.lineTo(pixelForX(dataX[i]), pixelForY(dataY[i]));
      }
    });

    return {
      stroke: new Map([
        ["#22c55e", greenPath],
        ["#ef4444", redPath],
      ]),
    };
  };

  $effect(() => {
    if (!container) return;

    if (chart) {
      chart.destroy();
    }

    const rect = container.getBoundingClientRect();
    const isDark = mode.current === "dark";
    const textColor = isDark ? "#ffffff" : "#000000";
    const gridColor = isDark ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.15)";

    const series = [
      {},
      {
        paths: coloredPath,
        width: 2,
      },
    ];

    chart = new uPlot(
      {
        width: Math.round(rect.width),
        height: Math.round(rect.height),
        scales: {
          x: { time: false },
        },
        axes: [
          {
            scale: "x",
            side: 2,
            stroke: textColor,
            grid: { stroke: gridColor },
            ticks: { stroke: gridColor, size: 5 },
            label: "Hand #",
            labelSize: 30,
            size: 50,
            values: (_self, splits) => splits.map((v) => Math.round(v)),
          },
          {
            scale: "y",
            side: 3,
            stroke: textColor,
            grid: { stroke: gridColor },
            ticks: { stroke: gridColor, size: 5 },
            label: "Profit",
            size: 50,
          },
        ],
        series,
        legend: { show: false },
      },
      data,
      container,
    );

    const handleResize = () => {
      const r = container.getBoundingClientRect();
      chart.setSize({ width: Math.round(r.width), height: Math.round(r.height) });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.destroy();
      chart = null;
    };
  });

  $effect(() => {
    if (chart && data) {
      chart.setData(data);
    }
  });
</script>

<div bind:this={container} class="w-full aspect-[3/2]"></div>

